import { render, staticRenderFns } from "./FlagsDropdown.vue?vue&type=template&id=7faad096&scoped=true&"
import script from "./FlagsDropdown.vue?vue&type=script&lang=js&"
export * from "./FlagsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FlagsDropdown.vue?vue&type=style&index=0&id=7faad096&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faad096",
  null
  
)

export default component.exports